import { render } from "./DropdownGeneric.vue?vue&type=template&id=d54d1292"
import script from "./DropdownGeneric.vue?vue&type=script&lang=ts"
export * from "./DropdownGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script